// Define explicit types for Piwik PRO consent types
export type ConsentStatus = 1 | 0; // 1 = Consented, 0 = Denied

export interface PiwikConsents {
    analytics?: { status: ConsentStatus };
    conversion_tracking?: { status: ConsentStatus };
    marketing?: { status: ConsentStatus };
    remarketing?: { status: ConsentStatus };
    user_feedback?: { status: ConsentStatus };
}

/**
 * Updates compliance and consent choices in Piwik PRO
 */
export const setPiwikInitialCompliance = (consents: PiwikConsents): Promise<any> => {
    return new Promise((resolve, reject) => {
        if (!window.ppms?.cm?.api) {
            return reject(new Error("Piwik PRO Consent Manager API is not available."));
        }

        window.ppms.cm.api(
            'setInitialComplianceSettings',
            { consents },
            (res) => resolve(res),
            (err) => reject(err)
        );
    });
};


/**
 * Updates compliance and consent choices in Piwik PRO
 */
export const setPiwikCompliance = (consents: PiwikConsents): Promise<any> => {
    return new Promise((resolve, reject) => {
        if (!window.ppms?.cm?.api) {
            return reject(new Error("Piwik PRO Consent Manager API is not available."));
        }

        window.ppms.cm.api(
            'setComplianceSettings',
            { consents },
            (res) => resolve(res),
            (err) => reject(err)
        );
    });
};

/**
 * Retrieves the current user compliance settings
 */
export const getPiwikCompliance = (): Promise<PiwikConsents> => {
    return new Promise((resolve, reject) => {
        if (!window.ppms?.cm?.api) {
            return reject(new Error("Piwik PRO Consent Manager API is not available."));
        }

        window.ppms.cm.api(
            'getComplianceSettings',
            undefined,
            (settings) => resolve(settings.consents),
            (err) => reject(err)
        );
    });
};
